import { useQuery } from '@tanstack/react-query';
import { useAppSelector } from '@redux/hooks';
import { Crew } from '@models/crew.model';
import { crewService } from '@services/crew';

/**
 * Prefix key. Mutation hooks invalidate with this, which prefix-matches every
 * per-organization entry below.
 */
export const CREWS_BY_USER_QUERY_KEY = ['crews'];

export const useCrews = () => {
  const { userId } = useAppSelector((state) => state.user);
  const organizationId = useAppSelector(
    (state) => state.organization.organizationId,
  );

  return useQuery<Crew[], Error>({
    queryKey: [...CREWS_BY_USER_QUERY_KEY, organizationId],
    enabled: !!userId,
    queryFn: async () => {
      if (!userId) throw new Error('userId is required');
      const crews = await crewService.getCrewsByUser(userId as string);
      return crews || [];
    },
  });
};

export default useCrews;
